module.exports = __webpack_public_path__ + "static/media/noData.a2ddf512.png";